import React from 'react';

interface ModalBodyProps {
  children: React.ReactNode;
  className?: string;
  padding?: boolean;
}

export const ModalBody: React.FC<ModalBodyProps> = ({ 
  children, 
  className = '', 
  padding = true 
}) => {
  return (
    <div className={`${padding ? 'p-6' : ''} ${className}`}>
      {children}
    </div>
  );
};